import React, {Component} from 'react'
import {Layout, Menu, Icon, Avatar,} from 'antd';
import {Link, withRouter} from 'react-router-dom'
import authorizeBase from "../authorize/authorizeBase";
import SiderLogo from '../../assets/images/siderLogo.png'
import userUtils, {getUserInfo} from "../../utills/userUtils";

const AuthMenuItem = authorizeBase(Menu.Item);
const {Sider,} = Layout;
const {SubMenu} = Menu;

class SiderMenu extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    componentWillMount() {
        getUserInfo().then((userInfo) => {
            this.setState({
                name: userInfo.name,
                authCode: userInfo.authCode,
            })
        })
    }

    render() {
        const path = this.props.location.pathname
        return (
            <Sider trigger={null} collapsible collapsed={false} style={{overflowY: 'auto', background: '#fff'}}>
                <div className='siderLogo' style={{background: '#1592D5', lineHeight: '56px', textAlign: 'center'}}>
                    <a href='http://55train.com'>
                        <img src={SiderLogo} alt="SiderLogo" style={{width: '100px'}}/>
                    </a>
                </div>
                <div className="sliderUser">
                    <div className='sider-user-info'>
                        <Avatar size={64} icon="user" className='siderAvatar'/>
                        <span className='sider-userName' onDoubleClick={() => {
                            userUtils.resetUserInfo()
                        }}>{this.state.name}</span>
                    </div>
                    <div className='sider-user-set'>
                        <span>
                             <Icon type="user" className='sider-info-icon'/>
                            <span className='sider-userName'>授权码：{this.state.authCode}</span>
                        </span>
                        {/*<span>
                         <Icon type="setting"  className='sider-info-icon'/>
                         <span className='sider-userName'>账号设置</span>
                         </span>*/}
                    </div>
                </div>
                <Menu theme="white" mode="inline" defaultSelectedKeys={[path]}
                      selectedKeys={[this.props.history.location.pathname]}>
                    <AuthMenuItem className='sider-nav-item' key="/" authority="page:index">
                        <Link to='/'>
                            <Icon type="home"/>
                            <span>首页</span>
                        </Link>
                    </AuthMenuItem>
                    <AuthMenuItem className='sider-nav-item' key="/domesticList" authority="order:edit">
                        <Link to='/domesticList'>
                            <Icon type="unordered-list"/>
                            <span>国内运输订单</span>
                        </Link>
                    </AuthMenuItem>
                    <AuthMenuItem className='sider-nav-item' key="/trackList" authority="order:edit">
                        <Link to='/trackList'>
                            <Icon type="unordered-list"/>
                            <span>出口运输订单</span>
                        </Link>
                    </AuthMenuItem>
                    <AuthMenuItem className='sider-nav-item' key="/deliveryList" authority="delivery:edit">
                        <Link to='/deliveryList'>
                            <Icon type="unordered-list"/>
                            <span>出口物流信息</span>
                        </Link>
                    </AuthMenuItem>
                    <AuthMenuItem className='sider-nav-item' key="/import/orderList" authority="order:edit">
                        <Link to='/import/orderList'>
                            <Icon type="unordered-list"/>
                            <span>进口运输订单</span>
                        </Link>
                    </AuthMenuItem>
                    <AuthMenuItem className='sider-nav-item' key="/importDeliveryList">
                        <Link to='/importDeliveryList'>
                            <Icon type="unordered-list"/>
                            <span>进口物流信息</span>
                        </Link>
                    </AuthMenuItem>
                    {/*<AuthMenuItem className='sider-nav-item' key="/timeliness" authority="order:edit">
                     <Link to='/timeliness'>
                     <Icon type="unordered-list" />
                     <span>时效分析</span>
                     </Link>
                     </AuthMenuItem>*/}
                    <AuthMenuItem className='sider-nav-item' key="/addrList" authority="address:edit">
                        <Link to='/addrList'>
                            <Icon type="unordered-list"/>
                            <span>地址管理</span>
                        </Link>
                    </AuthMenuItem>
                    <AuthMenuItem className='sider-nav-item' key="/barcodeList">
                        <Link to='/barcodeList'>
                            <Icon type="unordered-list"/>
                            <span>条形码管理</span>
                        </Link>
                    </AuthMenuItem>
                    <SubMenu key="sub1"
                             title={<span><Icon type="unordered-list"/><span>账单管理</span></span>}>
                        <Menu.Item className='sider-nav-item' key="/bill/clientList">
                            <Link to='/bill/clientList'>
                                <span>客户账单</span>
                            </Link>
                        </Menu.Item>
                        <Menu.Item className='sider-nav-item' key="/bill/reimburseList">
                            <Link to='/bill/reimburseList'>
                                <span>实报实销</span>
                            </Link>
                        </Menu.Item>
                    </SubMenu>
                </Menu>
            </Sider>
        )
    }
}

export default withRouter(SiderMenu)